import videojs from 'video.js';
import 'videojs-youtube';

const featuresPlayers = [];

const getSize = () => {
    const sizeMap = {
        "1440": {"width": 555, "height": 312},
        "1024": {"width": 443, "height": 249},
        "768": {"width": 612, "height": 345},
        "320": {"width": 291, "height": 164},
    };
    const widthList = [1440, 1024, 768, 320];

    for (const width of widthList) {
        if (width <= $(document).width()) {
            return sizeMap[width];
            break;
        }
    }

    return {"width": 291, "height": 164};
};

const getSizeFeatures = () => {
    const sizeMap = {
        "1440": {"width": 570, "height": 426},
        "1024": {"width": 496, "height": 370},
        "768": {"width": 369, "height": 276},
        "320": {"width": 292, "height": 218},
    };
    const widthList = [1440, 1024, 768, 320];

    for (const width of widthList) {
        if (width <= $(document).width()) {
            return sizeMap[width];
            break;
        }
    }

    return {"width": 290, "height": 218};
};

const featureVideoHandler = () => {
    const size = getSizeFeatures();

    $('.feature-video-js').each(function () {
        const player = videojs(
            $(this).attr('id'),
            {
                "width": size.width,
                "height": size.height,
                "controls": false,
                "autoplay": false,
            }
        );

        player.on('ready', function () {
            this.addClass('my-example');
        });

        featuresPlayers.push(player);
    });

    $('.video-content-tabs>span').on("click", function () {
        let index = $(this).index();
        const videoContentWrapper = $(this).parents('.video-content-wrapper');

        $(this).parent('.video-content-tabs').find('span').removeClass('active-button');
        $(this).addClass('active-button');

        videoContentWrapper.find('.video-content>iframe').each(function () {
            const src = $(this).attr('src');

            $(this).attr('src', '');
            $(this).attr('src', src);
        });

        videoContentWrapper.find('.right-side-video').hide();
        videoContentWrapper.find('.right-side-video:eq(' + index + ')').show();
    });
};

export const videoPlayerHandlers = () => {
    const size = getSize();

    // if ($('#vid1').length > 0) {
    //     const player = videojs(
    //         'vid1',
    //         {
    //             "sources": [{"type": "video/mp4", "src": "/videos/trailer1.mp4"}],
    //             "width": size.width,
    //             "height": size.height,
    //             "controls": true,
    //             "autoplay": false,
    //             "poster": "/videos/poster.png"
    //         }
    //     );
    //
    //     player.on('ready', function () {
    //         this.addClass('my-example');
    //     });
    // }

    // if ($('.index-promo__right-side iframe').length > 0) {
    //     $('.index-promo__right-side iframe').width(size.width);
    //     $('.index-promo__right-side iframe').height(size.height);
    // }

    featureVideoHandler();

    let videoPlayedOnce = [];

    $(window).scroll(function () {
        const scrollTopPosition = $(window).scrollTop() + $(window).height();
        const windowScrollTop = $(window).scrollTop();

        $('.feature-video-js').each(function (i, element) {
            videoPlayedOnce[i] = false;
            const elementJquery = $(element);
            const topOfElement = elementJquery.offset().top;
            const bottomOfElement = elementJquery.offset().top + elementJquery.outerHeight(true);
            const player = videojs(elementJquery.attr('id'));

            if (windowScrollTop > topOfElement && windowScrollTop < bottomOfElement) {

            } else if (windowScrollTop > bottomOfElement && windowScrollTop > topOfElement) {
                player.pause();
            } else if (scrollTopPosition < topOfElement && scrollTopPosition < bottomOfElement) {
                player.pause();
            } else if (scrollTopPosition < bottomOfElement && scrollTopPosition > topOfElement) {

            } else {
                if (!videoPlayedOnce[i]) {
                    featuresPlayers.forEach(playerElement => playerElement.pause());

                    player.play();
                    videoPlayedOnce[i] = true;
                }
            }
        });
    });
};
